<mat-form-field appearance="outline" subscriptSizing="dynamic">
  <mat-select
    [value]="country"
    (selectionChange)="onSelectionChange($event)"
    panelClass="country-select-panel"
    [placeholder]="'FORM_RE_REGISTRATION.FIELDS.COUNTRY.PLACEHOLDER' | translate"
  >
    <mat-select-trigger>
      @if (selectedOption(); as opt) {
        <span class="trigger-content">
          <img
            class="flag"
            [src]="opt.flag"
            [alt]="opt.code"
            width="20"
            height="13"
            decoding="async"
            (error)="onFlagError($event)"
          />
          {{ getCountryLabel(opt.code) }}
        </span>
      }
    </mat-select-trigger>

    @for (option of sortedOptions(); track option.code) {
      <mat-option [value]="option.code">
        <span class="option-content">
          <img
            class="flag"
            [src]="option.flag"
            [alt]="option.code"
            width="20"
            height="13"
            loading="lazy"
            decoding="async"
            (error)="onFlagError($event)"
          />
          {{ getCountryLabel(option.code) }}
        </span>
      </mat-option>
    }
  </mat-select>
</mat-form-field>
